var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoKigyou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24.09px",
    height: "21.68px",
    viewBox: "0 0 24.09 21.68",
    style: {
      enableBackground: "new 0 0 24.09 21.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1C4EC1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    className: "st0",
    d: "M16.86,16.86h2.41v-2.41h-2.41V16.86z M16.86,12.05h2.41V9.64h-2.41V12.05z M2.41,16.86h2.41 v2.41H2.41V16.86z M7.23,16.86h2.41v2.41H7.23L7.23,16.86z M2.41,12.05h2.41v2.41H2.41V12.05z M7.23,12.05h2.41v2.41H7.23 L7.23,12.05z M2.41,7.23h2.41v2.41H2.41V7.23z M7.23,7.23h2.41v2.41H7.23L7.23,7.23z M12.05,7.23h9.64v12.05h-9.64v-2.41h2.41v-2.41 h-2.41v-2.41h2.41V9.64h-2.41V7.23z M2.41,2.41h2.41v2.41H2.41V2.41z M7.23,2.41h2.41v2.41H7.23L7.23,2.41z M0,0v21.68h24.09V4.82 H12.05V0H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoKigyou);
export default __webpack_public_path__ + "static/media/ico_kigyou.e15219098104e4c6ed703089dfc53938.svg";
export { ForwardRef as ReactComponent };